webpackJsonp([70144966829960],{

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forms = __webpack_require__(36);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage(props) {
	    _classCallCheck(this, ContactPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      messageSent: false
	    };
	    return _this;
	  }
	
	  ContactPage.prototype.componentDidMount = function componentDidMount() {
	    (0, _utils.seoPageChange)();
	  };
	
	  ContactPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state$messageSent = this.state.messageSent,
	        messageSent = _state$messageSent === undefined ? false : _state$messageSent;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ContactPage' },
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(_components.StripeBG, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-row grid-column v-align h-align full-height full-8 grid-restrain ' },
	        _react2.default.createElement(
	          _components.PageAnimator,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'f1 t-center f-strong f-subdued s8' },
	              'Contact us'
	            ),
	            messageSent ? _react2.default.createElement(
	              'div',
	              { className: 'login-form s6 t-center f3 f-strong' },
	              'Thanks! We\'ll send you an email response ASAP! We are usually very quick.'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'login-form s6' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Get in touch with us! We usually respond very quickly.'
	              ),
	              _react2.default.createElement(_forms.ContactForm, { onSuccess: function onSuccess() {
	                  return _this2.setState({ messageSent: true });
	                } })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-69f8b09a450209fa0eae.js